module.exports = __webpack_public_path__ + "img/green_141.193821ef.png";